(function () {
  let loading = null;

  function isSliderVisible(slider) {
    if (!slider.isConnected) return false;
    let el = slider;
    while (el && el !== document.documentElement) {
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      el = el.parentElement;
    }
    return slider.getClientRects().length > 0;
  }

  function shouldInitFlickity(slider) {
    const cls = slider.className;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const mobileOnly = /\bmobile-only-\d+\b/.test(cls);
    const desktopOnly = /\bdesktop-only-\d+\b/.test(cls);
    if (mobileOnly && !isMobile) return false;
    if (desktopOnly && isMobile) return false;
    return true;
  }

  function destroySlider(slider) {
    if (slider.flickityInstance) {
      slider.flickityInstance.destroy();
      slider.flickityInstance = null;
    }
    slider.classList.remove('is-loaded');
  }

  function resizeSliders(container) {
    const root = container || document;
    root.querySelectorAll('[data-flickity]').forEach((slider) => {
      if (slider.flickityInstance) {
        slider.flickityInstance.resize();
      }
    });
  }

  function scheduleResize(container) {
    requestAnimationFrame(() => {
      resizeSliders(container);
      setTimeout(() => resizeSliders(container), 100);
      setTimeout(() => resizeSliders(container), 400);
      setTimeout(() => resizeSliders(container), 800);
    });
  }

  function bindResizeObserver(slider) {
    if (slider._flickityResizeObs || typeof ResizeObserver === 'undefined') return;
    slider._flickityResizeObs = new ResizeObserver(() => {
      if (slider.flickityInstance) {
        slider.flickityInstance.resize();
      }
    });
    slider._flickityResizeObs.observe(slider);
  }

  function bindImageLoadResize(container) {
    const root = container || document;
    root.querySelectorAll('[data-flickity] img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => resizeSliders(root), { once: true });
    });
  }

  window.ensureFlickityLoaded = function (callback) {
    if (window.Flickity) {
      callback();
      return;
    }

    const jsUrl = document.querySelector('meta[name="flickity-js"]')?.content;
    if (!jsUrl) return;

    if (!loading) {
      loading = new Promise((resolve) => {
        const cssUrl = document.querySelector('meta[name="flickity-css"]')?.content;
        const cssReady = document.querySelector('link[data-flickity-css], link[href*="flickity"]');

        function loadScript() {
          const script = document.createElement('script');
          script.src = jsUrl;
          script.onload = () => resolve();
          document.head.appendChild(script);
        }

        if (cssUrl && !cssReady) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = cssUrl;
          link.setAttribute('data-flickity-css', '');
          link.onload = loadScript;
          link.onerror = loadScript;
          document.head.appendChild(link);
        } else {
          loadScript();
        }
      });
    }

    loading.then(callback);
  };

  function initSlider(slider) {
    if (!shouldInitFlickity(slider)) {
      destroySlider(slider);
      return;
    }

    if (slider.flickityInstance) {
      slider.flickityInstance.destroy();
    }

    const options = JSON.parse(slider.getAttribute('data-flickity') || '{}');
    slider.flickityInstance = new Flickity(slider, options);
    slider.classList.add('is-loaded');
    slider.removeAttribute('data-flickity-deferred');

    bindResizeObserver(slider);

    requestAnimationFrame(() => {
      if (slider.flickityInstance) {
        slider.flickityInstance.resize();
      }
    });
  }

  function initFlickityIn(container) {
    const root = container || document;

    if (typeof initializeFlickity === 'function') {
      initializeFlickity(root);
    } else if (window.Flickity) {
      root.querySelectorAll('[data-flickity]').forEach((slider) => {
        if (!isSliderVisible(slider)) {
          slider.setAttribute('data-flickity-deferred', '');
          return;
        }
        if (!shouldInitFlickity(slider)) {
          destroySlider(slider);
          return;
        }
        initSlider(slider);
      });
    }

    bindImageLoadResize(root);
    scheduleResize(root);
  }

  window.refreshFlickityIn = function (container) {
    window.ensureFlickityLoaded(() => initFlickityIn(container || document));
  };

  window.resizeFlickityIn = function (container) {
    scheduleResize(container || document);
  };

  function boot() {
    if (!document.querySelector('[data-flickity]')) return;
    window.refreshFlickityIn(document);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => resizeSliders(document));
    }
  }

  if (document.readyState === 'complete') {
    boot();
  } else {
    window.addEventListener('load', boot);
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (document.querySelector('[data-flickity]')) {
        window.refreshFlickityIn(document);
      }
    }, 150);
  });

  document.addEventListener('shopify:section:load', (event) => {
    window.refreshFlickityIn(event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    window.refreshFlickityIn(event.target);
  });
})();
